
import { SupplierItem } from './supplier-item';
import { Promotion } from './promotion';

export interface SupplierPromotion  {
  supplier: SupplierItem;
  promotion: Promotion;
}
